<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
          <h3 class="text-center">Thème «{{ currentPerson.theme.name }}»</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-md-5 col-md-offset-4">
        <p style="text-align:center">Enregistrement(s) : {{ currentPerson.nbTexts.done + ' / ' + (currentPerson.nbTexts.total) + ' (' + (currentPerson.nbTexts.total - currentPerson.nbTexts.done) + ' restants)' }}</p>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-md-12">
        <div class="media">
          <div class="media-left">
            <a href="#">
              <img class="media-object" src="../assets/img/personnage.png">
            </a>
          </div>
          <div class="media-body">
            <p class="text-left">Personnage : «{{ currentPerson.name }}»</p>
            <p class="text-left">Genre : {{ currentPerson.gender == 'MALE'? 'Homme' : 'Femme'}}</p>
            <p class="text-left" v-if="currentPerson.description != ''">Description : {{ currentPerson.description }}</p>
            <button class="btn btn-info btn-sm" type="button" @click="toggleAsideList()">Afficher tous les textes du personnage</button>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-md-12">
        <button :disabled="!listIndex || !recordReady" class="btn btn-info pull-left btn-sm" type="button" @click="previousText()">Texte précédent</button>
        <button :disabled="listIndex == (texts.length - 1) || !recordReady" class="btn btn-info pull-right btn-sm" type="button" @click="nextText()">Texte suivant</button>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-md-12">
        <record :text="currentText" @upload="onUpload()" @ready="recordReady = true"></record>
        <vAside :show="showList" header="Texte(s)" :width="asideWidth" @close="showList = false">
            <div class="form-group form-inline">
                <label class="form-label">Rechercher : </label>
                <input class="form-control" type="text" v-model="search" placeholder="Id ou texte">
            </div>
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Texte</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody v-if="texts.length" class="list-group">
                    <tr v-for="(text, index) in texts" :key="text.id" @click="selectText(index)" :class="[text.id == currentText.id ? 'active' : '' , text.file ? 'list-group-item-success' : '' ]">
                        <td v-html="text.id"></td>
                        <td v-html="showContent(text)"></td>
                        <td>
                            <button class="btn btn-info btn-sm" type="button">Sélectionner</button>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                <tr>
                    <td>
                        Aucun texte.
                    </td>
                </tr>
                </tbody>
            </table>
        </vAside>
      </div>
  </div>
</div>
</template>


<script>
	import {aside as VAside} from 'vue-strap'
    import Record from 'components/Record'

    export default {
        components: {
            Record,
            VAside
        },
        computed: {
            currentPerson: function() {
                return this.$store.state.user.currentUserPerson;
            },
            texts: function() {
                return this.search != '' ? this.currentPerson.texts.filter((text) => text.id.toString().includes(this.search.toLowerCase()) || text.content.toLowerCase().includes(this.search.toLowerCase())) : this.currentPerson.texts;
            },
            currentText: function()	{
        		return this.texts[this.listIndex];
        	},
            allGood()   {
                return this.currentPerson.nbTexts.done == this.currentPerson.nbTexts.total;
            },
            asideWidth() {
                return window.innerWidth * 4 / 5;   
            }
        },
        methods: {
            selectText(index)    {
                this.listIndex = index;
                this.$children[0].cleanSounds();
                this.$children[0].initSavedFile();
                this.toggleAsideList();
            },
            showContent(text)   {
                if (text.id == this.currentText.id){
                    return text.content;
                }
                return text.content.substring(0, 42) + (text.content.length > 42 ?  '...' : '');
            },
            onUpload()   {
                this.nextText();
            },
            toggleAsideList()	{
            	this.showList = !this.showList;
            },
            previousText()  {
                if (this.listIndex)    {
                    this.listIndex -= 1;
                    // let offset = 0;
                    // for (let i = 1; this.listIndex - i >= 0; i++) {
                    //     if (!this.texts[this.listIndex - i].file)    {
                    //         offset = i;
                    //         break;
                    //     }
                    // }
                    // this.listIndex -= offset ? offset : 1;
                    this.$children[0].cleanSounds();
                    this.$children[0].initSavedFile();
                    // this.recordReady = false;
                    return true;
                }
            },
            nextText()  {
                let limit = this.texts.length - 1;
                if (this.listIndex != limit)    {
                    this.listIndex += 1;
                    // let offset = 0;
                    // for (let i = 1; this.listIndex + i <= limit; i++) {
                    //     if (!this.texts[this.listIndex + i].file)    {
                    //         offset = i;
                    //         break;
                    //     }
                    // }
                    // this.listIndex += offset ? offset : 1;                       
                    this.$children[0].cleanSounds();
                    this.$children[0].initSavedFile();
                    // this.recordReady = false;
                }
                if (this.allGood)   {
                    this.allGoodAlert();
                }
            },
            allGoodAlert()   {
                this.$store.commit('ALERT_DATA_UPDATED', {
                        text: "Bravo ! Vous avez fini l'enregistrement des voix de ce personnage.",
                        type: 'success'
                });
            }
        },
        data: function()  {
            return {
            	showList: false,
                listIndex: 0,
                recordReady: false,
                search: ''
            };
        },
        created()	{
            let startIndex = 0;
            if (this.texts[startIndex]) {
                while (this.texts[startIndex].file)    {
                    ++startIndex;
                }                
            }
            this.listIndex = startIndex;
        	this.showList = false;
		},
        beforeCreate()  {
            this.$emit('navbarUpdate', {
                text: 'Retour aux personnages',
                pathData: {
                    name: "UserPersonList",
                    params: {
                        userId: this.$route.params.userId
                    }
                }
            });
        }
    };
</script>

<style>


</style>
